import React, { ReactNode } from 'react';
import { FormControl, Typography } from '@mui/material';
import { useField } from 'formik';
import { capitalize } from 'lodash';
import { ISelectOption } from '../../../../types/sharedFormTypes';
import { SelectPanel } from './SelectPanel';

interface Props {
  children?: ReactNode;
  label?: string;
  subLabel?: string;
  noLabel?: boolean;
  name: string;
  placeholder?: string;
  required?: boolean;
  readOnly?: boolean;
  options?: Array<string>;
  objectOptions?: Array<ISelectOption>;
}
export function FieldSelect(props: Props) {
  const { label, subLabel, noLabel, name, placeholder, required } = props;
  const [field, meta] = useField(name);

  const placeholderText =
    placeholder || `Select ${(label || name).toLowerCase()}`;

  return (
    <FormControl
      className="flex flex-col gap-2 w-full relative min-h-[90px]"
      fullWidth
    >
      {!noLabel && (
        <Typography variant="body1" color="var(--text)">
          {capitalize(label || name)}
          {subLabel && <span className="text-muted"> ({subLabel})</span>}
          {required && <span className="ml-2 text-text-2">*</span>}
        </Typography>
      )}

      <SelectPanel
        {...props}
        placeholder={placeholderText}
        fieldProps={field}
      />

      {!!meta.touched && !!meta.error && (
        <div className="-bottom-0 absolute">
          <Typography variant="caption" color="error">
            {meta.error}
          </Typography>
        </div>
      )}
    </FormControl>
  );
}
